module.exports = __webpack_public_path__ + "img/13_en.5011175e.png";